if (window.webpackPublicPath) {
  __webpack_public_path__ = window.webpackPublicPath; // eslint-disable-line no-undef
}
